<!-- static content data from lang: past_script_details -->
<template>
  <div class="container h-100">
    <div class="py-3 h-100" v-loading="loading">
      <template v-if="errored">
        <NotFound />
      </template>
      <template v-else-if="data">
        <b-card class="script-details">
          <template slot="header">
            <div class="d-flex justify-content-center">
              <h5 class="id mb-0">{{ lang.label.rejectHeader }}</h5>
            </div>
          </template>
          <div class="full-detail" >
            <div class="row">
              <div class="col-md-12">
                <b-card class="card-box" body-class="p-0">
                  <div class="row">
                    <div class="col-6">
                      <span class="my-2 d-block">{{ lang.label.patientName }}:</span>
                    </div>
                    <div class="col-6">
                      <span class="my-2 d-block">{{
                        data.patientName != "" ? data.patientName : lang.label.nodata
                      }}</span>
                    </div>
                    <div class="col-6">
                        <span class="my-2 d-block">{{lang.label.gender}}:</span>
                    </div>
                    <div class="col-6">
                        <span class="my-2 d-block">{{(data.genderValue!=''? data.genderValue :lang.label.nodata)}}</span>
                    </div>
                    <div class="col-6">
                      <span class="my-2 d-block">{{ lang.label.dob }}:</span>
                    </div>
                    <div class="col-6">
                      <span class="my-2 d-block">{{
                        data.dob != "" ? data.dob : lang.label.nodata
                      }}</span>
                    </div>
                    <div class="col-6">
                      <span class="my-2 d-block">{{ lang.label.idNumber }}:</span>
                    </div>
                    <div class="col-6">
                      <span class="my-2 d-block">{{
                        data.idNumber != "" ? data.idNumber : lang.label.nodata
                      }}</span>
                    </div>
                    <div class="col-6">
                      <span class="my-2 d-block">{{ lang.label.email }}:</span>
                    </div>
                    <div class="col-6">
                      <span class="my-2 d-block">{{
                        data.email != "" ? data.email : lang.label.nodata
                      }}</span>
                    </div>

                    <div class="col-6">
                      <span class="my-2 d-block">{{ lang.label.phoneNumber }}:</span>
                    </div>
                    <div class="col-6">
                      <span class="my-2 d-block">{{
                        data.mobile != "" ? data.mobile : lang.label.nodata
                      }}</span>
                    </div>
                    <div class="col-12">
                        <hr/>
                    </div>
                    <div class="col-12" v-if="data.formName != ''">
                        <b> <span class="my-2 d-block"><h5>{{data.formName}}</h5></span></b>
                    </div>

                   <div class="col-12" v-for="fdata in data.formDetails">
                      <div class="row">
                          <div class="col-6">
                          <span
                            class="my-2 d-block"
                            :class="{'text-danger': fdata.key && fdata.key.toLowerCase().includes('allergies')}"
                          >
                              {{ fdata.key }}
                          </span>
                      </div>
                      <div class="col-6">
                          <span class="my-2 d-block" :class="{'text-danger': fdata.key && fdata.key.toLowerCase().includes('allergies')}">
                              {{ fdata.value }}
                          </span>
                      </div>
                      </div>
                  </div>
                    <div></div>
                     <div class="col-12">
                        <hr/>
                    </div>
                    
                    <div class="col-6">
                        <span class="my-2 d-block">{{lang.label.nurseNote}}:</span>
                    </div>
                    <div class="col-6">
                        <span class="my-2 d-block">{{ (data.nurseNote!=''? data.nurseNote :lang.label.nodata)}}</span>
                    </div>
                   
                     <div class="col-12">
                        <hr/>
                    </div>
            
                    <div class="col-6">
                      <span class="my-2 d-block">{{lang.label.patientImages}}:</span>
                    </div>
                    <div class="col-6">
                      <carousel autoplay loop v-if="data.formImages.length">
                          <slide v-for="(image,index) in [...data.formImages]" v-bind:key="index" class="d-flex justify-content-center align-items-center">
                              <img :src="image" height="200" width="200">
                          </slide>
                      </carousel>
                      <span v-else>{{ lang.label.nodata }}</span>
                    </div>

                    <div class="col-12">
                        <hr/>
                    </div>

                    <!-- Prescription / Script media: show images if available, otherwise text prescription -->
                    <div class="col-6">
                        <span class="my-2 d-block">{{lang.label.prescription}}:</span>
                    </div>
                    <div class="col-6">
                      <!-- If scriptMedia has any entries, prefer showing images -->
                      <template v-if="data.scriptMedia && data.scriptMedia.length">
                        <carousel autoplay loop>
                          <slide
                            v-for="(media, index) in data.scriptMedia"
                            :key="'script-media-' + index"
                            v-if="media.type === 'image'"
                            class="d-flex flex-column justify-content-center align-items-center"
                          >
                            <img
                              :src="media.file"
                              height="100"
                              width="100"
                              class="mb-2"
                            />
                            <b-button
                              size="sm"
                              variant="link"
                              :href="media.file"
                              target="_blank"
                              class="p-0"
                              @click.stop
                            >
                              <i class="fas fa-eye"></i>
                            </b-button>
                          </slide>
                        </carousel>
                      </template>
                      <!-- Fallback to text prescription if no scriptMedia images -->
                      <span
                        v-else-if="data.prescription"
                        class="my-2 d-block"
                        v-html="formatPrescription(data.prescription)"
                      ></span>
                      <!-- Final fallback -->
                      <span v-else>{{ lang.label.nodata }}</span>
                    </div>

                    <div class="col-12">
                        <hr/>
                    </div>

                     <div class="col-6">
                        <span class="my-2 d-block">{{lang.label.medication_needed}}:</span>
                    </div>
                    <div class="col-6">
                        <span class="my-2 d-block">{{ (data.notes!=''? data.notes :lang.label.nodata)}}</span>
                    </div>

                    <div class="col-12">
                        <hr/>
                    </div>

                    <div class="col-6">
                        <span class="my-2 d-block">{{lang.label.rejectReason}}:</span>
                    </div>
                    <div class="col-6">
                        <span class="my-2 d-block">{{ (data.rejectReason!=''? data.rejectReason :lang.label.nodata)}}</span>
                    </div>


                                        
                  </div>
                  <div class="row">
                    <div class="col-md-4 mt-2">
                      <b-form-group class="mb-0 btn-mt">
                        <b-btn
                          type="submit"
                          variant="primary"
                          class="w-100"
                          @click="openModal"
                          >{{ lang.label.buttons.sendNote }}
                        </b-btn>
                      </b-form-group>
                    </div>
                    <div class="col-md-4 mt-2">
                      <b-form-group class="mb-0 btn-mt">
                        <b-btn
                          type="button"
                          variant="primary"
                          class="w-100"
                          v-clipboard:copy="data.sharedUrl"
                          v-clipboard:success="onCopy"
                          v-clipboard:error="onError"
                        >
                          {{ data.prescription
                            ? lang.label.buttons.copyEScript
                            : lang.label.buttons.copyScript }}
                        </b-btn>
                      </b-form-group>
                    </div>
                    <div class="col-md-4 mt-2">
                      <b-form-group class="mb-0 btn-mt">
                        <a
                          class="btn btn-primary w-100"
                          style="color: #fff"
                          :href="mailDetails"
                          target="_blank"
                        >
                          {{
                            data.prescription
                              ? lang.label.buttons.shareEScript
                              : lang.label.buttons.shareScript
                          }}
                        </a>
                      </b-form-group>
                    </div>
                  </div>
                </b-card>
              </div>
            </div>
          </div>
        </b-card>
      </template>
    </div>
    <b-modal
      id="modal-center"
      ref="send_note"
      centered
      :title="lang.label.noteForPatient"
      hide-footer
    >
      <ValidationObserver ref="observer" v-slot="{ passes }">
        <b-form @submit.stop.prevent="passes(onSubmit)">
          <b-form-group>
            <div class="row">
              <div class="col-12 col-md-12">
                <label class="label-control" for="name">
                  {{ lang.label.note }}:
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-12 col-md-12">
                <ValidationProvider
                  name="reason"
                  rules="required"
                  v-slot="validationContext"
                >
                  <b-form-textarea
                    :state="getValidationState(validationContext)"
                    v-model="note"
                    ref="prescription"
                    type="text"
                    :placeholder="lang.label.enterNote"
                    rows="3"
                    max-rows="3"
                  ></b-form-textarea>
                  <b-form-invalid-feedback
                    style="color: red; font-size: 12px"
                    v-if="validationContext.failedRules.required"
                  >
                    {{ lang.label.noteRequired }}</b-form-invalid-feedback
                  >
                  <!--<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>-->
                </ValidationProvider>
              </div>
            </div>
          </b-form-group>
          <div class="mt-3">
            <b-btn type="submit" :disabled="onSend" variant="primary" class="w-100">{{
              lang.label.buttons.submit
            }}</b-btn>
          </div>
        </b-form>
      </ValidationObserver>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import jsondata from "../assets/json/data.json";
import VueSilentbox from "vue-silentbox";

Vue.use(VueSilentbox);
import VueClipboard from "vue-clipboard2";
import { mapGetters } from "vuex";

Vue.use(VueClipboard);
var moment = require("moment"); // require
import NotFound from "../components/NotFound.vue";

export default {
  components: {
    NotFound,
  },
  data() {
    return {
      data: {},
      mailDetails: "",
      shareUrl: "",
      note: "",
      id: this.$route.params.id,
      lang: this.$lang.group_request_details,
      images: [],
      pdf: [],
      loading: true,
      errored: false,
      models: {
        idNumber: "",
        patientMinor: [],
        parentName: "",
        parentIDNumber: "",
        medicineRequired: "",
        specialInstructions: "",
        
      },
      onSend: false,
    };
  },
  computed: {
    ...mapGetters({
      login: "login",
      groupRequestDetails: "groupRequestDetails",
      frompath:"frompath"
    }),
  },
  mounted() {
    this.data = this.groupRequestDetails;
    this.loading = false;
    this.mailDetails = this.scriptDetails();
  },
  methods: {
    formatAddress(address) {
      return address.replace(/\n/g, "<br/>");
    },
    scriptDetail() {
      //                return 'Dear '+this.data.patientsName+', you submitted a request for a script / form to '+this.login.name+'. If you requested the document, please click this link '+'"' +this.data.shared_url +'"'+' to make payment and download the document. Thank you, '+this.login.name;
    },
    scriptDetails() {
      let subject =
        "mailto:" +
        this.data.pEmail +
        "?subject=Payscript – Script / Form from " +
        this.login.practiceName +
        " &body=";
      let body =
        "Dear " +
        this.data.patientsName +
        "," +
        "%0D%0A%0D%0A" +
        "You submitted a request for a script / form to " +
        this.login.practiceName +
        ". If you requested the document, please " +
        "OPEN " +
        this.data.sharedUrl +
        " to pay and access the document." +
        "%0D%0A%0D%0A" +
        "Thank you, %0D%0A" +
        this.login.practiceName;
      return subject + body;
    },
    formatDob(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatScriptDate(date) {
      let format = moment(date).format("Do MMM YYYY");
      moment.locale("en", {
        ordinal: (num) => {
          const b = num % 10;
          const output =
            ~~((num % 100) / 10) === 1
              ? "th"
              : b === 1
              ? "st"
              : b === 2
              ? "nd"
              : b === 3
              ? "rd"
              : "th";
          return num + "<sup>" + output + "</sup>";
        },
      });

      return moment(date).format("Do MMM YYYY");
    },
    onCopy: function (e) {
      if (this.data.sharedUrl != "") {
        return this.notifyVue("success");
      } else {
        return this.notifyVueError("error");
      }
    },
    onError: function (e) {
      this.notifyVueError("error");
    },
    notifyVue(type = "success") {
      this.$notify({
        message: this.lang.label.copiedlink,
        timeout: 5000,
        type,
      });
    },
    notifyVueError(type = "error") {
      this.$notify({
        message: this.lang.label.errorIncopyLink,
        timeout: 5000,

        type,
      });
    },
    formatAddress(address) {
      if (address) {
        return address.replace(/\n/g, "<br/>");
      }
    },
    formatPrescription(prescription) {
      if (prescription) {
        return prescription.replace(/\n/g, "<br/>");
      }
    },
    Download(url) {
      url = this.pdf;
      document.getElementById("my_iframe").src = url;
    },
    openModal() {
      this.$refs.send_note.show();
    },
    onSubmit() {
      let self = this;
      self.onSend = true;
      self.loading=true;
      // let params = {
      //   note: this.note,
      //   groupRequestId: this.data.groupRequestId,
      // };
      let params = {
        note: this.note,
        formsManagementId: this.data.formsManagementId,
      };
      this.$store.dispatch("sendNoteToNurse", params).then((value) => {
        console.log("value", value);
        self.onSend = false;
        if (value.message) {
          self.loading=false;
          setTimeout(()=>{
            self.open(value.message);
            self.onSend = false;
            self.$refs.send_note.hide();
          },50)
          
        }
      });
    },
    open(message) {
      let self = this;
      this.$alert(message, "", {
        confirmButtonText: "OK",
        callback: (action) => {
          this.$refs.send_note.hide();
          this.$router.push({ name: "home" });
        },
      });
    },
    createScript() {},
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    pastScript(patient){
      this.$store.commit('setPatientInfo',patient);
      this.$store.commit('setFromGroupRequests', true);
      this.$router.push({name: 'past-script',params: {flag: true}});
    }
  },
};
</script>
